// extracted by mini-css-extract-plugin
module.exports = {"breadCrumbElement":"styles_breadCrumbElement__d9SlL","crumbLink":"styles_crumbLink__xETgl"};